import { useState } from "react";
import { useApp } from "../app/AppContext";
import { useProjectMutations } from "../lib/queries";
import { priColor } from "../lib/tasks";
import { ColorSwatches, PROJECT_COLORS } from "./ColorSwatches";

export function SideRail() {
  const app = useApp();
  const projectMut = useProjectMutations();
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");
  const [color, setColor] = useState(PROJECT_COLORS[0]!);

  const openTasks = app.tasks.filter((t) => t.status !== "done");
  const countFor = (pid: string) => openTasks.filter((t) => t.projectId === pid).length;

  const backlog = app.tasks
    .filter(
      (t) =>
        t.status !== "done" &&
        t.doDate !== app.today &&
        (app.filter === "all" || t.projectId === app.filter),
    )
    .sort((a, b) => a.pri - b.pri)
    .slice(0, 40);

  function addProject(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    projectMut.create.mutate({ name: name.trim(), color });
    setName("");
    setColor(PROJECT_COLORS[0]!);
    setAdding(false);
  }

  return (
    <nav className="rail">
      <div className="hrow">
        <div className="h">Projects</div>
        <button className="mini" aria-label="New project" onClick={() => setAdding((v) => !v)}>
          +
        </button>
      </div>

      {adding && (
        <form onSubmit={addProject} className="rail-padd">
          <input
            className="inp"
            style={{ width: "100%", fontSize: 12, padding: "6px 8px" }}
            autoFocus
            placeholder="Project name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <ColorSwatches value={color} onPick={setColor} />
        </form>
      )}

      <div className="chanlist">
        <button
          className={`chan${app.filter === "all" ? " on" : ""}`}
          onClick={() => app.setFilter("all")}
        >
          <span className="dot" style={{ background: "#8A93AD", color: "#8A93AD" }} />
          All
          <span className="cnt">{openTasks.length}</span>
        </button>
        {app.projects.map((p) => (
          <button
            key={p.id}
            className={`chan${app.filter === p.id ? " on" : ""}`}
            onClick={() => app.setFilter(p.id)}
          >
            <span className="dot" style={{ background: p.color, color: p.color }} />
            {p.name}
            <span className="cnt">{countFor(p.id)}</span>
          </button>
        ))}
      </div>

      <details open>
        <summary className="h" style={{ cursor: "pointer", marginTop: 18, marginBottom: 10 }}>
          Backlog
        </summary>
        <div>
          {backlog.length === 0 && <div className="empty">Backlog clear.</div>}
          {backlog.map((t) => (
            <div
              key={t.id}
              className="bk"
              draggable
              onDragStart={(e) => e.dataTransfer.setData("text/plain", t.id)}
            >
              <span
                className="pri"
                style={{ background: priColor(t.pri), color: priColor(t.pri), marginTop: 0 }}
              />
              <span className="bkt" style={{ cursor: "pointer" }} onClick={() => app.openTask(t.id)}>
                {t.title}
              </span>
              <span className="en">
                {t.energy === "high" ? "⚡ " : ""}
                {t.doDate ? t.doDate.slice(5) : ""}
              </span>
            </div>
          ))}
        </div>
      </details>
    </nav>
  );
}
